import React, { Component, Fragment } from "react";

import { Metric, selectFormat } from "components/Utils/Utils.js";
import Heading from "../Elements/Heading";

import { PieChart, Pie, Cell } from "recharts";

const COLORS = ["#FAA461", "#f4f4f4"];

class DonationsSummary extends Component {
  render() {
    const { data } = this.props;

    return (
      <Fragment>
        <div className="row mt-2 d-flex align-items-end">
          <div className="col-4 col-md-3 mb-3 mb-md-4">
            <Heading size={6} className="mb-1">
              Total Dollars Donated
            </Heading>
            <Metric {...data.total_dollars} type={"currency"} size="lg" />
          </div>

          <div className="col-4 col-md-3 mb-3 mb-md-4">
            <Heading size={6} className={"mb-1"}>
              Unique Donors
            </Heading>
            <Metric {...data.unique_donors} size={"lg"} />
          </div>

          <div className="col-4 col-md-2 mb-3 mb-md-4 border-single">
            <Heading size={6} className={"mb-1"}>
              New Orders
            </Heading>
            <Metric {...data.new_orders} size={"lg"} />
          </div>

          <div className="col-4 col-md-2 mb-3 mb-md-4">
            <Heading size={6} className={"mb-1"}>
              1st Time Donors
            </Heading>
            <Metric {...data.first_time_donors_value} size={"lg"} />
          </div>

          <div className="col-4 col-md-2 mb-md-1">
            <Heading size={6} className={"mb-1"}>
              <span className="text-capitalize">
                New Orders from {data.top_donations_source_name}
              </span>
            </Heading>
            <PieChart height={70} width={70}>
              <Pie
                dataKey="value"
                data={data.top_donations_source_value}
                outerRadius="100%"
                innerRadius="65%"
              >
                {data.top_donations_source_value.map((entry, index) => (
                  <Cell key={`cell-${entry}`} fill={COLORS[index]} />
                ))}
              </Pie>
              <text
                x="50%"
                y="50%"
                textAnchor="middle"
                dominantBaseline="middle"
                className="piechart-metric__small"
              >
                {selectFormat(
                  "percentage",
                  data.top_donations_source_value[0].value
                )}
              </text>
            </PieChart>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default DonationsSummary;
